
import 'dayjs/locale/zh-cn' // load on demand
import dayjs from "dayjs";

dayjs.locale('zh-cn')

var dateDto = {};

dateDto.format = (date) => {
     return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
};

dateDto.format = (date, dateFormatStr) => {
     return dayjs(date).format(dateFormatStr);
};

export default dateDto;